import Type from "@/model/types/Type";

const type = {
    MINUTE: 1,
    HOUR: 2,
    DAY: 3,
    WEEK: 4,
    MONTH: 5,
    YEAR: 6,
}

const list = [
    {
        value: type.MINUTE,
        text: "Minuto",
    },
    {
        value: type.HOUR,
        text: "Hora",
    },
    {
        value: type.DAY,
        text: "Dia",
    },
    {
        value: type.WEEK,
        text: "Semana",
    },
    {
        value: type.MONTH,
        text: "Mês",
    },
    {
        value: type.YEAR,
        text: "Ano",
    },

]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}